// extracted by mini-css-extract-plugin
export default {"trigger":"MoreLessText-trigger___E2ZJ2","trigger_isTriggerInline":"MoreLessText-trigger_isTriggerInline___Qbnx8"};